/**
 * API error surfacing helpers
 * Reads the normalized error properties set by the response interceptor.
 */

/**
 * Maps a 422 validation error into a flat { field: message } object.
 * The interceptor writes `error.validationErrors = data.errors` on 422.
 * Laravel's `errors` shape: { field: [msg1, msg2, ...] }
 *
 * @param {Error} error - Axios error with optional validationErrors
 * @returns {{ [field: string]: string }} Field → first error message map
 */
export function getFieldErrors(error) {
  const raw = error?.validationErrors;
  if (!raw || typeof raw !== 'object') return {};

  return Object.fromEntries(
    Object.entries(raw).map(([field, messages]) => [
      field,
      Array.isArray(messages) ? messages[0] : String(messages),
    ])
  );
}

/**
 * Returns a user-readable message set by the response interceptor.
 * Falls back to a generic French message when none is set.
 *
 * @param {Error} error - Axios error with optional userMessage
 * @returns {string}
 */
export function getUserMessage(error) {
  return (
    error?.userMessage ||
    error?.response?.data?.message ||
    "Une erreur s'est produite."
  );
}
